<template>
    <div class="flex">
        <div class="p-3">
            <s-item width="40px" height="40px" borderRadius="50%"></s-item>
        </div>
        <div class="flex-1 p-3">
            <s-item height="20px" ></s-item>
            <s-item height="20px" ></s-item>
        </div>
        
        
    </div>
</template>

<script>
import SItem from './Item'
export default {
    components : {
        SItem
    }
}
</script>